import React from "react";
import FormationBuilderPage from "../FormationBuilderPage";

const Lighting = () => {
  const LightingProgram = [
    {
      title: "Architecture des feux",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title: "Bases de l’optique",
      img: "/assets/images/icon/tuyaux.svg",
    },
    {
      title: "La thermique",
      img: "/assets/images/icon/work.svg",
    },
    {
      title: "Injection plastique/rhéologie",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title:
        "Géometrie/Cotation/Iso statisme/ Dispersion/Réglage (MAP)/ Chaine de cote/Qualité Perçue",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "Consommation (rendement énergétique)",
      img: "/assets/images/icon/work-women.svg",
    },
    {
      title: "Réglementation Auto ECE48",
      img: "/assets/images/icon/redaction.svg",
    },
    {
      title: "Réglementation Ferro",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title: "Réglementation Aéro",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "Choc piéton dans l’environnement AUTO",
      img: "/assets/images/icon/balance.svg",
    },
    {
      title: "Systèmes optiques pour l’éclairage extérieur et performance",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "Eclairage intérieur et performance Auto / Ferro / Aéro",
      img: "/assets/images/icon/network-card.svg",
    },
    {
      title: "Electrique / Electronique",
      img: "/assets/images/icon/component-card.svg",
    },
    {
      title: "Découverte du monde de l’automobile (Produit/ process)",
      img: "/assets/images/icon/setting.svg",
    },
    {
      title: "Architecture Véhicule Thermique / Electrique / Hybride",
      img: "/assets/images/icon/setting.svg",
    },
    {
      title: "Animation de réunion",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title: "Prise de parole",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "Rédaction de synthèse",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title: "Management de projet",
      img: "/assets/images/icon/setting-square.svg",
    },
    {
      title: "Planning Constructeurs & Equipementiers (V3P +PIV)",
      img: "/assets/images/icon/light.svg",
    },
    {
      title: "Logiciels de planification et de gestion JIRA",
      img: "/assets/images/icon/light.svg",
    },
    {
      title: "Logiciels de planification et de gestion MS PROJECT",
      img: "/assets/images/icon/light.svg",
    },
    {
      title: "Design",
      img: "/assets/images/icon/light.svg",
    },
    {
      title: "Excel + VBA",
      img: "/assets/images/icon/light.svg",
    },
    {
      title: "Power Point (animation)",
      img: "/assets/images/icon/light.svg",
    },
    {
      title:
        "Canalyzer- Compréhension du signal CAN (Solari sur la durée) Protocole CAN/LINdonnées d’entrée",
      img: "/assets/images/icon/light.svg",
    },
    {
      title: "Diagalyzer (Diagnostique - durée mini)",
      img: "/assets/images/icon/light.svg",
    },
    {
      title: "DDT2000 (Outil RSA)",
      img: "/assets/images/icon/light.svg",
    },
    {
      title: "Construction d’un plan de Validation",
      img: "/assets/images/icon/light.svg",
    },
    {
      title: "Construction d’un plan de Homologation",
      img: "/assets/images/icon/light.svg",
    },
    {
      title: "CATIA V5",
      img: "/assets/images/icon/light.svg",
    },
    {
      title: "3D experience",
      img: "/assets/images/icon/light.svg",
    },
    {
      title: "Anglais technique - Vocabulaire",
      img: "/assets/images/icon/light.svg",
    },
    {
      title: "Immersion projet",
      img: "/assets/images/icon/light.svg",
    },
  ];

  return (
    <FormationBuilderPage
      category="Automobile"
      titleColor="#2424FF"
      title="Lighting"
      duration={11}
      description={
        <React.Fragment>
          <p>
            Grâce au partenariat entre Liora et SEGULA Technologies, rejoignez
            un groupe d’ingénierie mondiale à forte croissance en tant que
            Lighting, après une formation accélérée de 11 semaines.
          </p>
          <p>
            Impression 3D, réalité augmentée, véhicule autonome, usine du
            futur... rythment le quotidien de nos 13 000 ingénieux
            collaborateurs, pourquoi pas le vôtre ?
          </p>
        </React.Fragment>
      }
      image="/assets/images/home/automobile.png"
      program={LightingProgram}
      formId="ae01a9a0-6ca5-42d5-adaa-26f7645e0e54"
    />
  );
};

export default Lighting;
